/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { Row, Col, Card, CardText, CardBody } from 'reactstrap';
import { DefaultTooltipContent } from 'recharts/lib/component/DefaultTooltipContent';
import { LineChart,Line, XAxis, YAxis, CartesianGrid, Tooltip, Label, Legend, ResponsiveContainer } from 'recharts';
import PropTypes from 'prop-types';
import moment from 'moment';
import { monthWithDays } from '../../helper';
import { setCurrencyFormat, colorsCombination } from '../../../../utils/helpers';

export const CustomTooltip = (props) => {
    // eslint-disable-next-line react/prop-types
    const { active, payload } = props;
    // we don't need to check payload[0] as there's a better prop for this purpose
    if (!active) {
      // I think returning null works based on this: http://recharts.org/en-US/examples/CustomContentOfTooltip
      return null
    }
    // mutating props directly is against react's conventions
    // so we create a new payload with the name and value fields set to what we want
    // eslint-disable-next-line react/prop-types
  
    const newPayload = Object.values(payload).sort((a, b) => a.value < b.value ? 1 : -1).map((item) => {
        const updated = { ...item }
        updated.value = setCurrencyFormat(Number(item?.value).toFixed(2), true);
        return updated;
    })    
    // we render the default, but with our overridden payload
    return <DefaultTooltipContent {...props} payload={newPayload} />;
  };

const SalesByProductChart = ({ dir, showTitle, categorisedBasedOn, index,
    dataToShow, height, category }) => {
    const thisMonthData = {};
    const currentDataByYear = {};
    const [color1, color2, color3] = colorsCombination[index % 10];

    const currentCatData = Object.keys(dataToShow);    
    const dataToPlot = [];    
    return (         
         <ResponsiveContainer height={height}>
         <LineChart
             // data={dataToPlot?.[0]}
             margin={{
             top: 60, right: 0, left: 25, bottom: 0,
             }}
         >
             <XAxis dataKey="day" type="category" allowDuplicatedCategory={false} />
             <YAxis orientation={dir === 'rtl' ? 'right' : 'left'}
                 tickFormatter={item => setCurrencyFormat(item, true)}
                 width={90}
                 dataKey="Amount"
                 allowDataOverflow
             />
             <CartesianGrid vertical={false} horizontal  stroke="#FF0000" strokeWidth={2} />
             <Tooltip content={<CustomTooltip />} />
             {/* <Tooltip formatter={value => setCurrencyFormat(value, true)} /> */}
             <Legend />
             {dataToShow?.map((label, lineIndex) => (
                 <Line dot={false} type="monotone" dataKey="Amount" data={label.data} name={label.name} key={label.name} stroke={label.color || '#3366ff'} strokeWidth={1} />
             ))}
            
         </LineChart>
     </ResponsiveContainer>
    )
}

SalesByProductChart.propTypes = {
    dir: PropTypes.string.isRequired,
    dataToShow: PropTypes.object.isRequired,
    height: PropTypes.number.isRequired,
    showTitle: PropTypes.bool,
    category: PropTypes.string.isRequired,
    categorisedBasedOn: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired
    // eslint-disable-next-line react/forbid-prop-types
};

SalesByProductChart.defaultProps = {
    showTitle: true
  }

export default React.memo(SalesByProductChart);